// Which subs and specials a player may use. The first few are free; the rest are bought in the Shop (SPECIALS tab) or
// won from loot crates, and are stored on the profile as 'sub_<id>' / 'special_<id>' inventory ids like every other item.
// (A weapon's own default sub and special always come with it.)
export const FREE_SUBS = ['bomb', 'sticky', 'burst'];
export const FREE_SPECIALS = ['slam', 'storm', 'barrage'];

const inv = (prof) => (prof && Array.isArray(prof.inventory) ? prof.inventory : []);
export const ownsSub = (prof, id) => FREE_SUBS.includes(id) || inv(prof).includes('sub_' + id);
export const ownsSpecial = (prof, id) => FREE_SPECIALS.includes(id) || inv(prof).includes('special_' + id);

// Shop prices in gems (0 = free starter). Loot-crate rarity follows the price: 600+ rare, 900+ epic.
export const SUB_PRICE = {
  bomb: 0, sticky: 0, burst: 0,
  tracer: 450, scan: 450, shaker: 500, mine: 500, curtain: 550, sprinkler: 550, mist: 550,
  beacon: 600, seeker: 600, waddle: 600, torpedo: 700, boomerang: 700,
};
export const SPECIAL_PRICE = {
  slam: 0, storm: 0, barrage: 0,
  sonar: 600, bubbler: 650, barrage_sticky: 700, barrage_burst: 700, barrage_seeker: 700, barrage_mist: 700,
  blower: 750, strike: 800, zooka: 800, stamp: 900, wail: 950, jetpack: 1000, kraken: 1100, zipcaster: 1100, booyah: 1200, crab: 1300,
};
export const SPECIAL_SHOP_NAME = {
  barrage: 'Barrage', barrage_sticky: 'Cling Barrage', barrage_burst: 'Cannon Barrage', barrage_seeker: 'Seeker Barrage', barrage_mist: 'Mist Barrage',
};
